import React, { Component } from 'react';
import ShapeIcon from './ShapeIcon';
import _ from 'lodash';
import { SIDES, SPIN_DURATION } from '../const';
import { delay, playSound } from '../../HOME/utils';

class Cell extends Component {
  constructor(props) {
    super(props);

    if (!props) {
      return;
    }

    this.state = { transition: 'initial' };

    const { row, col } = props.cell;
    this.area = `${row}/${col}`;
    this.translate = `translate(${1 - col}px, ${1 - row}px)`;
  }

  componentWillUpdate() {
    if (this.props.cell.reveal) {
      this.props.cell.reveal = false;

      let turns = this.props.cell.turns % 4;

      if (!turns) {
        return;
      }

      if (turns < 3) {
        turns = -turns;
      } else {
        turns = 1;
      }

      this.doRotate(turns > 0, Math.abs(turns), 2000);
    }
  }

  widthAdjuster = () => {
    const sides = this.props.mode === SIDES;

    switch (this.props.shape) {
      case 'circle':
        return sides ? 0.85 : 1.15;
      case 'square':
        return sides ? 0.75 : 1.05;
      case 'rhombus':
        return sides ? 1.1 : 1.4;
      case 'star':
        return sides ? 1.05 : 1.35;
      case 'segments':
        return sides ? 0.8 : 1.1;
      case 'hearts':
        return sides ? 0.95 : 1.2;
      case 'cog':
        return sides ? 0.95 : 1.3;
      case 'swastika':
        return sides ? 1.05 : 1.3;
      case 'celtic':
        return sides ? 0.8 : 1.1;
      default:
    }
  };

  positionShape = i => {
    let p;

    if (this.props.mode === SIDES) {
      switch (i) {
        case 0:
          p = ['start', 'center', 0, -1];
          break;
        case 1:
          p = ['center', 'end', 1, 0];
          break;
        case 2:
          p = ['end', 'center', 0, 1];
          break;
        case 3:
          p = ['center', 'start', -1, 0];
          break;
        default:
      }
    } else {
      switch (i) {
        case 0:
          p = ['start', 'start', -1, -1];
          break;
        case 1:
          p = ['start', 'end', 1, -1];
          break;
        case 2:
          p = ['end', 'end', 1, 1];
          break;
        case 3:
          p = ['end', 'start', -1, 1];
          break;
        default:
      }
    }

    return { align: p[0], justify: p[1], x: p[2] * 50, y: p[3] * 50 };
  };

  doRotate = (clockwise, count = 1, ms = 600) => {
    this.props.cell.turns += clockwise ? count : -count;
    this.props.cell.rotating = true;

    this.setState({ transition: `transform ${ms}ms linear` }, () => {
      delay(() => {
        if (this.props.board.surrender) {
          playSound(this.props.board.props, 'cluck');
          this.props.board.surrender = false;
        }

        this.setState({ transition: 'initial' });

        delay(() => {
          this.props.cell.rotating = false;
          this.props.board.updateAligned();
        }, 500);
      }, ms);
    });
  };

  handleTouch = clockwise => {
    this.touch = true;
    this.handleClick(clockwise);
  };

  handleMouseDown = clockwise => {
    if (!this.touch) {
      this.handleClick(clockwise);
    }
  };

  handleClick = clockwise => {
    const { board } = this.props;

    if (board.blocked) {
      return;
    }

    board.props.showHelp(false);

    if (board.state.over) {
      board.restart();
      return;
    }

    board.props.updateSteps();
    playSound(board.props, 'click');
    board.block(true);

    this.doRotate(clockwise);

    delay(() => {
      playSound(board.props, 'cluck');
      board.block(false);
    }, 600);
  };

  render() {
    const { width, shape, board } = this.props;
    const { colors, aligned, spin, turns, reveal } = this.props.cell;
    const shapeWidth = (width / 2) * this.widthAdjuster();
    const style = board.state.over && !reveal ? { border: 0 } : {};
    const cellTransform = `rotate(${turns * 90}deg)`;

    return (
      <div style={{ display: 'grid', width, gridArea: this.area, transform: this.translate }}>
        <div className="tt-cell" style={{ ...style, height: width, transform: cellTransform, transition: this.state.transition }}>
          {_.map([0, 1, 2, 3], i => {
            const p = this.positionShape(i);
            const alignSelf = p.align;
            const justifySelf = p.justify;
            const rotations = spin ? turns + 4 : board.state.over ? turns : -turns;
            const shapeTransform = `translate(${p.x}%, ${p.y}%) rotate(${rotations * 90}deg)`;
            const transition = spin ? `transform ${SPIN_DURATION}ms linear` : board.state.over ? 'initial' : this.state.transition;

            return (
              <ShapeIcon
                key={i}
                shape={shape}
                width={shapeWidth}
                color={board.palette[colors[i]]}
                style={{ gridArea: '1/1', alignSelf, justifySelf, transform: shapeTransform, transition }}
              />
            );
          })}
          {aligned ? null : <div className="tt-misaligned-dot" />}
        </div>
        <div
          style={{ gridArea: '1/1', width: '50%', zIndex: 1 }}
          onTouchStart={() => this.handleTouch(false)}
          onMouseDown={() => this.handleMouseDown(false)}
        />
        <div
          style={{ gridArea: '1/1', width: '50%', justifySelf: 'end', zIndex: 1 }}
          onTouchStart={() => this.handleTouch(true)}
          onMouseDown={() => this.handleMouseDown(true)}
        />
      </div>
    );
  }
}

export default Cell;
